import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=729def56&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=729def56&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729def56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('729def56')) {
      api.createRecord('729def56', component.options)
    } else {
      api.reload('729def56', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=729def56&scoped=true", function () {
      api.rerender('729def56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/layout/components/AppMain.vue"
export default component.exports